import React from 'react';
import Sidenavigation from '../layout/Sidenavigation';
import Topnavigation from '../layout/Topnavigation';
import Details from '../../vendor/section/VendorOrderDetails/Details';
import { Helmet } from "react-helmet";

export default function VendorOrderDetails() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme">
            {/* title */}
            <Helmet>
                <title>Order Details</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end  */}

            <main className="body-content">

                {/* Topnavigation start  */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Details />
                {/* page content end  */}

            </main>

        </div>
    );
};